import { create } from 'zustand'

import { safeStorage } from './storage.ts'

/**
 * **작업 줄에 띄울 작업을 사람이 고른 값** — 클라 UI 상태다(eric 2026-10-22
 * 「작업 목록으로 이동하면서 동시에 작업 선택을 하면.. 대기 중이거나 준비 중인 작업 선택해서.. 선택하게 해줘.」).
 *
 * 🔴 **서버 상태가 아니다.** 「무엇을 보고 있는가」라는 화면의 선택일 뿐이라 서버에 쓰지 않고
 *    쿼리 캐시에도 두지 않는다. 작업의 상태 · 허용 명령은 여전히 서버 응답이 정한다.
 * 🔴 **값은 «작업 id 하나»뿐이다.** 그 작업이 지금 고를 만한지(시작 전인가 · 목록에 있는가 · 끝났는가)는
 *    읽는 쪽(`pickStripBatch`)이 매번 서버 목록에 대 본다 — 여기서 판정하지 않는다. 그래서 고른 작업이
 *    끝나거나 사라지면 저장된 id 가 남아 있어도 **조용히 무시된다.**
 * - 새로 고쳐도 남는다 — 토큰과 같은 `session` 저장소(탭 단위)에 둔다. 저장이 막혀도 이번 세션에선 적용된다.
 */
export const STRIP_CHOICE_STORAGE_KEY = 'ctcells:strip-batch'

interface StripChoiceState {
  /** 고른 작업 id. 고른 적이 없으면 `undefined` */
  chosenBatchId: string | undefined
  // 화살표 타입 — 셀렉터로 꺼내 쓸 때 unbound-method 경고를 피한다(appearanceStore 와 같다)
  choose: (batchId: string) => void
  clear: () => void
}

function readStored(): string | undefined {
  const raw = safeStorage.read(STRIP_CHOICE_STORAGE_KEY, 'session')
  return raw === null || raw === '' ? undefined : raw
}

export const useStripChoiceStore = create<StripChoiceState>((set) => ({
  chosenBatchId: readStored(),

  choose: (batchId) => {
    safeStorage.write(STRIP_CHOICE_STORAGE_KEY, batchId, 'session')
    set({ chosenBatchId: batchId })
  },

  clear: () => {
    safeStorage.remove(STRIP_CHOICE_STORAGE_KEY, 'session')
    set({ chosenBatchId: undefined })
  },
}))

/** 고른 작업 id 만 읽는 훅 — 작업 줄 · 모니터링 따라가기 · 시료 흐름이 같은 값을 읽는다 */
export function useChosenStripBatchId(): string | undefined {
  return useStripChoiceStore((state) => state.chosenBatchId)
}
